import { connect } from 'react-redux';
import SalesOrders from './SalesOrders';
import {
  getSO,
  getSORP,
  rebindSORP
} from '../../store/actions/so';
import { modalErrorOpen } from '../../store/actions/modalError';

const mapStateToProps = ({
  soReducer,
  tabsReducer,
  userReducer
}) => ({
  soReducer,
  tabsReducer,
  userReducer
});
const mapDispatchToProps = {
  getSO,
  getSORP,
  rebindSORP,
  modalErrorOpen
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SalesOrders);
